import { Container, Accordion } from '@mui/material'
import AccordionHeader from './AccordionHeader'
import styles from './AccordionConatiner.module.scss'

const AccordionConatiner = ({isExpand, children, ...props}) => {
    return(
        <Container className={styles[isExpand ? 'open' : 'close']} maxWidth="xl" component="section">
            <Accordion className={styles['GraphsContainer']} elevation={3} expanded={isExpand}>
                <AccordionHeader {...props}/>
                <div className={styles["aaccordionPadded"]}>
                    {children}
                </div>
            </Accordion>
        </Container>
    )
}

export default AccordionConatiner